import { internalFetch } from '../utils/fetchHelper';
import type { WorkActualsServices } from '@moko/ui';
const api = import.meta.env.VITE_BACKEND_API_URL as string;
export const workActualsServices: WorkActualsServices = {
  load: (controller, id) =>
    internalFetch(`${api}/p/work/${id}/actuals`, 'GET', controller),
  loadReceipts: async (controller, id) => {
    const receipts: { id: number; label: string }[] = [];
    for (let pageNo = 1; ; pageNo++) {
      const result = (await internalFetch(
        `${api}/p/workImages?workId=${id}&pageSize=100&pageNo=${pageNo}`,
        'GET',
        controller
      )) as { items: { id: number; caption?: string }[] };
      receipts.push(
        ...result.items.map((i) => ({
          id: i.id,
          label: i.caption || `Photo ${i.id}`,
        }))
      );
      if (result.items.length < 100) return receipts;
    }
  },
  save: (controller, id, request, approve) =>
    internalFetch(
      `${api}/p/work/${id}/actuals${approve ? '/approve' : ''}`,
      'POST',
      controller,
      JSON.stringify(request)
    ),
};
